<div
    class="container"
    [class.show]="showDialog"
    #customGraphDialog
    [ngStyle]="{ height: isFixed ? '100%' : '644px' }"
>
    <div
        class="header"
        (mousedown)="mouseDown($event)"
        (touchstart)="mouseDown($event)"
        #header
    >
        <h4 data-cy="graphs-customization-window-title">
            {{ "custom-graph.dialog.title" | translate }}
        </h4>
        <div style="display: flex; gap: 16px; align-items: center">
            <mat-icon
                data-cy="graphs-customization-window-pin-icon"
                (click)="fixDialog()"
                class="close-icon"
                [svgIcon]="isFixed ? 'open-as-tab' : 'fix-to-window'"
            ></mat-icon>
            <mat-icon
                data-cy="graphs-customization-window-x-icon"
                (click)="close()"
                class="close-icon"
                svgIcon="close"
            ></mat-icon>
        </div>
    </div>

    <div class="content">
        <div class="channel-selection-container">
            <h5 class="channel-selection-title">
                {{ "custom-graph.dialog.channel-selection" | translate }}
            </h5>
            <app-search-channel-group
                [page]="CUSTOM_GRAPH_PAGE"
                [editChannels]="
                    selectedCustomGraphItem?.channel
                        ? [
                              {
                                  name: selectedCustomGraphItem?.channel.opsData
                                      .name,
                                  channelId:
                                      selectedCustomGraphItem?.channel.id,
                                  fcuChannelId:
                                      selectedCustomGraphItem?.channel.fcuData
                                          .fcuChannelId,
                              },
                          ]
                        : []
                "
                (onChannelsSelected)="channelSelect($event)"
                (onShowingTable)="(null)"
                (onShowPreview)="(null)"
            >
            </app-search-channel-group>
            <div data-cy="graphs-customization-window-graph-settings-container" class="graph-setting-container" [class.show]="selectedChannel">
                <h5 class="graph-setting-title">
                    {{ "custom-graph.dialog.graph-setting" | translate }}
                </h5>
                <div class="selected-channel">
                    <span
                        data-cy="graphs-customization-window-selected-channel"
                        >{{
                            '"' +
                                selectedChannel?.opsData?.name +
                                '" ' +
                                ("custom-graph.dialog.selected-channel-message"
                                    | translate)
                        }}</span
                    >
                    <span
                        data-cy="graphs-customization-window-remove-button"
                        class="remove"
                        (click)="removeClick()"
                        >{{ "custom-graph.dialog.remove" | translate }}</span
                    >
                </div>
                <div class="graph-option-container">
                    <mat-radio-group
                        aria-labelledby="radio-group-label"
                        class="radio-group"
                        [value]="selectedCustomGraphItem?.type"
                        [(ngModel)]="selectedType"
                        (ngModelChange)="changeSelectedGroupOption()"
                    >
                        <mat-radio-button
                            data-cy="graphs-customization-window-graph-type-button"
                            *ngFor="let graphOption of graphOptionList"
                            class="radio-button"
                            [value]="graphOption"
                            [class.disable]="optionDisable(graphOption)"
                            >{{ graphOption }}</mat-radio-button
                        >
                    </mat-radio-group>
                </div>
            </div>
            <div class="division-container" *ngIf="selectedType === GAUGE">
                <h4 class="division-title">
                    {{ "custom-graph.dialog.division.title" | translate }}
                </h4>
                <div class="division">
                    <div
                        class="division-button minus"
                        (click)="minusDivisions()"
                    >
                        <mat-icon
                            data-cy="graphs-customization-window-graph-division-count-minus-button"
                            class="division-icon"
                            svgIcon="minus"
                        ></mat-icon>
                    </div>
                    <input
                        #divisionInput
                        data-cy="graphs-customization-window-graph-division-count-input-field"
                        class="division-input"
                        type="number"
                        [value]="
                            selectedCustomGraphItem?.divisions
                                ? selectedCustomGraphItem?.divisions
                                : 6
                        "
                        [(ngModel)]="divisions"
                        [max]="MAX_DIVISIONS"
                        (ngModelChange)="divisionsChange()"
                    />
                    <div class="division-button plus" (click)="plusDivisions()">
                        <mat-icon
                            data-cy="graphs-customization-window-graph-division-count-plus-button"
                            class="division-icon"
                            svgIcon="plus"
                        ></mat-icon>
                    </div>
                </div>
            </div>

            <!--FOR NOW THIS IS DISABLED -->
            <div
                class="channel-setting-container"
                *ngIf="selectedType === INDICATOR && false"
            >
                <div *ngIf="selectedType" class="show-alarms-setting-container">
                    <mat-checkbox
                        class="checkbox"
                        [(ngModel)]="alarmSettingShow"
                        (ngModelChange)="alarmSettingShowChange()"
                    />
                    <span class="show-alarms-setting">
                        {{
                            "custom-graph.dialog.division.set-channel-message"
                                | translate
                        }}
                    </span>
                </div>
                <!-- Digital Alarms -->
                <div *ngIf="isDigital()">
                    <app-ops-accordion
                        #accordions
                        #digitalAccordion
                        [isOpen]="false"
                    >
                        <div
                            ops-accordion-header
                            class="alarm-accordion-header subtitle-small bold"
                        >
                            <div>
                                {{
                                    "forms.channel.alarm.alarm-labels.digital"
                                        | translate
                                }}
                            </div>
                            <div class="subtitle-small light">
                                {{ digitalAccordion.isOpen ? "-" : "+" }}
                            </div>
                        </div>
                        <div ops-accordion-content class="alarm-accordion-body">
                            <app-alarm-setting-form
                                [validator]="validators.alarmSetting"
                                [alarm]="selectedChannel.fcuData.alarmSetting"
                                [measurementUnits]="
                                    selectedChannel.opsData.measurementUnit
                                "
                                (onSubmit)="emitSubmit('alarmSetting', $event)"
                                (onDelete)="emitDelete('alarmSetting', $event)"
                                [channel]="selectedChannel"
                            ></app-alarm-setting-form>
                        </div>
                    </app-ops-accordion>
                </div>
                <!-- Analog Alarms -->
                <div
                    class="alarms-container-spacing"
                    *ngIf="alarmSettingShow && !isDigital()"
                >
                    <!-- Very High Alarm -->
                    <app-ops-accordion
                        #accordions
                        #veryHighAccordion
                        [isOpen]="false"
                        class="form-container"
                    >
                        <div
                            ops-accordion-header
                            class="alarm-accordion-header subtitle-small bold"
                        >
                            <div>
                                {{
                                    "forms.channel.alarm.alarm-labels.very-high"
                                        | translate
                                }}
                            </div>
                            <div class="subtitle-small light">
                                {{ veryHighAccordion.isOpen ? "-" : "+" }}
                            </div>
                        </div>
                        <div ops-accordion-content class="alarm-accordion-body">
                            <app-alarm-setting-form
                                [validator]="validators.veryHigh"
                                [alarm]="
                                    selectedChannel.fcuData.alarmSettingVeryHigh
                                "
                                [measurementUnits]="
                                    selectedChannel.opsData.measurementUnit
                                "
                                (onSubmit)="
                                    emitSubmit('alarmSettingVeryHigh', $event)
                                "
                                (onDelete)="
                                    emitDelete('alarmSettingVeryHigh', $event)
                                "
                                [channel]="selectedChannel"
                            ></app-alarm-setting-form>
                        </div>
                    </app-ops-accordion>

                    <!-- High Alarm -->
                    <app-ops-accordion
                        #accordions
                        #highAccordion
                        [isOpen]="false"
                        class="form-container"
                    >
                        <div
                            ops-accordion-header
                            class="alarm-accordion-header subtitle-small bold"
                        >
                            <div>
                                {{
                                    "forms.channel.alarm.alarm-labels.high"
                                        | translate
                                }}
                            </div>
                            <div class="subtitle-small light">
                                {{ highAccordion.isOpen ? "-" : "+" }}
                            </div>
                        </div>
                        <div ops-accordion-content class="alarm-accordion-body">
                            <app-alarm-setting-form
                                [validator]="validators.high"
                                [alarm]="
                                    selectedChannel.fcuData.alarmSettingHigh
                                "
                                [measurementUnits]="
                                    selectedChannel.opsData.measurementUnit
                                "
                                (onSubmit)="
                                    emitSubmit('alarmSettingHigh', $event)
                                "
                                (onDelete)="
                                    emitDelete('alarmSettingHigh', $event)
                                "
                                [channel]="selectedChannel"
                            ></app-alarm-setting-form>
                        </div>
                    </app-ops-accordion>

                    <!-- Low Alarm -->
                    <app-ops-accordion
                        #accordions
                        #lowAccordion
                        [isOpen]="false"
                        class="form-container"
                    >
                        <div
                            ops-accordion-header
                            class="alarm-accordion-header subtitle-small bold"
                        >
                            <div>
                                {{
                                    "forms.channel.alarm.alarm-labels.low"
                                        | translate
                                }}
                            </div>
                            <div class="subtitle-small light">
                                {{ lowAccordion.isOpen ? "-" : "+" }}
                            </div>
                        </div>
                        <div ops-accordion-content class="alarm-accordion-body">
                            <app-alarm-setting-form
                                [validator]="validators.low"
                                [alarm]="
                                    selectedChannel.fcuData.alarmSettingLow
                                "
                                [measurementUnits]="
                                    selectedChannel.opsData.measurementUnit
                                "
                                (onSubmit)="
                                    emitSubmit('alarmSettingLow', $event)
                                "
                                (onDelete)="
                                    emitDelete('alarmSettingLow', $event)
                                "
                                [channel]="selectedChannel"
                            ></app-alarm-setting-form>
                        </div>
                    </app-ops-accordion>

                    <!-- Very Low Alarm -->
                    <app-ops-accordion
                        #accordions
                        #veryLowAccordion
                        [isOpen]="false"
                        class="form-container"
                    >
                        <div
                            ops-accordion-header
                            class="alarm-accordion-header subtitle-small bold"
                        >
                            <div>
                                {{
                                    "forms.channel.alarm.alarm-labels.very-low"
                                        | translate
                                }}
                            </div>
                            <div class="subtitle-small light">
                                {{ veryLowAccordion.isOpen ? "-" : "+" }}
                            </div>
                        </div>
                        <div ops-accordion-content class="alarm-accordion-body">
                            <app-alarm-setting-form
                                [validator]="validators.veryLow"
                                [alarm]="
                                    selectedChannel.fcuData.alarmSettingVeryLow
                                "
                                [measurementUnits]="
                                    selectedChannel.opsData.measurementUnit
                                "
                                (onSubmit)="
                                    emitSubmit('alarmSettingVeryLow', $event)
                                "
                                (onDelete)="
                                    emitDelete('alarmSettingVeryLow', $event)
                                "
                                [channel]="selectedChannel"
                            ></app-alarm-setting-form>
                        </div>
                    </app-ops-accordion>

                    <!-- Feedback Error Alarm -->
                    <app-ops-accordion
                        #accordions
                        #feedbackErrorAccordion
                        [isOpen]="false"
                        class="form-container"
                    >
                        <div
                            ops-accordion-header
                            class="alarm-accordion-header subtitle-small bold"
                        >
                            <div>
                                {{
                                    "forms.channel.alarm.alarm-labels.feedback"
                                        | translate
                                }}
                            </div>
                            <div class="subtitle-small light">
                                {{ feedbackErrorAccordion.isOpen ? "-" : "+" }}
                            </div>
                        </div>
                        <div ops-accordion-content class="alarm-accordion-body">
                            <app-alarm-setting-form
                                [validator]="validators.feedback"
                                [isFeedbackAlarm]="true"
                                [alarm]="
                                    selectedChannel.fcuData
                                        .alarmSettingFeedbackError
                                "
                                [measurementUnits]="
                                    selectedChannel.opsData.measurementUnit
                                "
                                [disableFields]="['setPoint']"
                                (onSubmit)="
                                    emitSubmit(
                                        'alarmSettingFeedbackError',
                                        $event
                                    )
                                "
                                (onDelete)="
                                    emitDelete(
                                        'alarmSettingFeedbackError',
                                        $event
                                    )
                                "
                                [channel]="selectedChannel"
                            ></app-alarm-setting-form>
                        </div>
                    </app-ops-accordion>
                </div>
            </div>
        </div>
    </div>
</div>
